import React from "react";
import styled from "styled-components";
import { Flex, Box } from "reflexbox";

import { Link } from "../Link";
import * as colors from "../../styles/colors";

import crownImage from "../../../static/crown-profile-transparent.png";

const CTAContainer = styled(Flex)`
  background: ${colors.darkThemeColor};
  border: 1px solid rgba(96, 113, 123, 0.15);
  border-radius: 16px;
  padding: 48px 32px;
  margin: 40px 0 !important;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(42, 199, 220, 0.3) 50%,
      transparent 100%
    );
  }

  @media (max-width: 768px) {
    padding: 36px 20px;
  }
`;

const CrownImage = styled.img`
  width: 300px;
  height: auto;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    width: 240px;
  }
`;

export function InlineAppCTA({
  text = "",
  label = "Get Your Crown",
  href = "/crown"
}) {
  return (
    <CTAContainer
      flexDirection="column"
      alignItems="center"
      width="100%"
    >
      <CrownImage
        src={crownImage}
        alt="Neurosity Crown"
        loading="lazy"
      />
      {text ? (
        <Box
          fontSize={[15, 16]}
          color={colors.text}
          mb={[4]}
          style={{ lineHeight: "165%", maxWidth: 480 }}
        >
          {text}
        </Box>
      ) : null}
      <Link to={href} type="buttonSecondary">
        {label}
      </Link>
    </CTAContainer>
  );
}
